/** Installed Fluid light-theme token --nj-core-color-purple-600.
 * Pinned value: Mapbox cannot interpret CSS custom properties.
 * Shared by the local legend and GeoJSON, including UMMap's offline style.
 */
export const PIPE_COLOR = '#9261b7';
export type NetworkDisplay = 'pipes' | 'density';
